import { useRef } from "react";

// Wraps children with mouse-follow 3D tilt. CSS handles the transform via --mx / --my.
export default function TiltCard({ as: Tag = "div", className = "", children, testId, ...rest }) {
  const ref = useRef(null);

  const onMove = (e) => {
    const el = ref.current;
    if (!el) return;
    const rect = el.getBoundingClientRect();
    const mx = (e.clientX - rect.left) / rect.width - 0.5;   // -0.5 → 0.5
    const my = (e.clientY - rect.top) / rect.height - 0.5;
    el.style.setProperty("--mx", mx.toFixed(3));
    el.style.setProperty("--my", my.toFixed(3));
  };

  const onLeave = () => {
    const el = ref.current;
    if (!el) return;
    el.style.setProperty("--mx", 0);
    el.style.setProperty("--my", 0);
  };

  return (
    <Tag
      ref={ref}
      onMouseMove={onMove}
      onMouseLeave={onLeave}
      data-testid={testId}
      className={`tilt-card ${className}`}
      {...rest}
    >
      {children}
    </Tag>
  );
}
